/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { Oas20Document } from '../../openapi/v2/models/Oas20Document';
import { Oas20ResponseDefinition } from '../../openapi/v2/models/Oas20ResponseDefinition';
import { NewResponseDefinitionCommand } from './NewResponseDefinitionCommand';
import { Oas20ResponseDefinitions } from '../../openapi/v2/models/Oas20ResponseDefinitions';

/**
 * @author eric.wittmann@gmail.com
 * @extends NewResponseDefinitionCommand
 * @class
 */
export class NewResponseDefinitionCommand_20 extends NewResponseDefinitionCommand {
    public _nullResponses : boolean;

    public constructor(definitionName? : any, description? : any) {
        if(((typeof definitionName === 'string') || definitionName === null) && ((typeof description === 'string') || description === null)) {
            let __args = arguments;
            super();
            if(this._nullResponses===undefined) this._nullResponses = false;
            if(this._nullResponses===undefined) this._nullResponses = false;
            (() => {
                this._newDefinitionName = definitionName;
                this._newDefinitionDescription = description;
            })();
        } else if(definitionName === undefined && description === undefined) {
            let __args = arguments;
            super();
            if(this._nullResponses===undefined) this._nullResponses = false;
            if(this._nullResponses===undefined) this._nullResponses = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewResponseDefinitionCommand] Executing.");
        let doc20 : Oas20Document = <Oas20Document>document;
        if(this.isNullOrUndefined(doc20.responses)) {
            doc20.responses = doc20.createResponseDefinitions();
            this._nullResponses = true;
        }
        if(this.isNullOrUndefined(doc20.responses.getResponse(this._newDefinitionName))) {
            let responseDef : Oas20ResponseDefinition = doc20.responses.createResponse(this._newDefinitionName);
            if(ModelUtils.isDefined(this._newDefinitionDescription)) {
                responseDef.description = this._newDefinitionDescription;
            }
            doc20.responses.addResponse(this._newDefinitionName, responseDef);
            this._defExisted = false;
        } else {
            this._defExisted = true;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewResponseDefinitionCommand] Reverting.");
        let doc20 : Oas20Document = <Oas20Document>document;
        if(this._nullResponses) {
            doc20.responses = null;
        }
        if(this._defExisted) {
            return;
        }
        doc20.responses.removeResponse(this._newDefinitionName);
    }
}
NewResponseDefinitionCommand_20["__class"] = "io.apicurio.datamodels.cmd.commands.NewResponseDefinitionCommand_20";
NewResponseDefinitionCommand_20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




